import React from 'react';
import { lazyForPaint } from 'react-loosely-lazy';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import Placeholder from '@atlassian/jira-placeholder';

const LazyBenefitModal = lazyForPaint(
	() => import(/* webpackChunkName: "async-proforma-forms-settings-benefit-modal" */ './main'),
);

const BenefitModal = () => (
	<Placeholder name="proforma-forms-settings-benefit-modal" fallback={<></>}>
		<LazyBenefitModal />
	</Placeholder>
);

export const AsyncBenefitModal = () => (
	<JSErrorBoundary
		id="ProformaFormsSettings"
		packageName="jiraProformaFormSettingsBenefitModal"
		teamName="jsm-request-intake"
	>
		<BenefitModal />
	</JSErrorBoundary>
);
